export const offerIncludes: string[] = [
  '6 Complete Visual Teaching Volumes',
  '150 Ready-to-Teach Makeup Classes',
  'Step-by-Step Technique Guides',
  'Visual Demonstrations',
  'Student Practice Activities',
  'Common Mistakes & Corrections',
  'Assessment Tools',
  'Complete-Look Progressions',
  'Beginner-to-Advanced Structure',
  '100 Makeup Student Mistakes & Instructor Corrections',
  'Makeup Technique Demonstration Guide',
  'Student Assessment & Skill Progression System',
  '50 Makeup Practice Labs & Classroom Activities',
  'Makeup Instructor Class Planning & Teaching Toolkit',
  'Finished PDF Resources',
  'Instant Digital Access',
  '7-Day Guarantee',
]

export const everythingIncluded: string[] = [
  'Volume 01 — Makeup Foundations, Hygiene & Professional Setup',
  'Volume 02 — Complexion, Color Correction & Base Techniques',
  'Volume 03 — Eyes, Brows, Lashes & Precision Techniques',
  'Volume 04 — Lips, Face Balance & Complete Makeup Looks',
  'Volume 05 — Bridal, Mature Skin, Diverse Clients & Advanced Applications',
  'Volume 06 — 150 Ready-to-Teach Makeup Classes',
  '150 Ready-to-Teach Classes',
  'Completely Visual Teaching System',
  'Step-by-Step Technique Guides',
  'Visual Demonstrations',
  'Student Practice Activities',
  'Instructor Correction Tools',
  'Professional Assessment Resources',
  'Bonus 01 — 100 Makeup Student Mistakes & Instructor Corrections',
  'Bonus 02 — Makeup Technique Demonstration Guide',
  'Bonus 03 — Student Assessment & Skill Progression System',
  'Bonus 04 — 50 Makeup Practice Labs & Classroom Activities',
  'Bonus 05 — Makeup Instructor Class Planning & Teaching Toolkit',
  'Instant Digital Access',
  '7-Day Guarantee',
]

export const painCosts: string[] = [
  'Hours spent preparing upcoming classes.',
  "Repeating the same exercises because they're already familiar.",
  'Searching through scattered tutorials, notes and references.',
  'Knowing a technique but not always knowing the clearest way to teach it.',
  'Demonstrating too much while students spend too little time practicing.',
  'Correcting the same mistakes without a structured correction process.',
  'Difficulty measuring real student progress.',
  'Improvising activities because the class was not completely prepared.',
  'Taking lesson planning home after your workday is already over.',
  'Walking into class wishing you had prepared more.',
]

export const scratchTasks: string[] = [
  'Searching for techniques.',
  'Saving tutorials.',
  'Designing activities.',
  'Preparing demonstrations.',
  'Creating assessments.',
  'Planning what comes next.',
]

export const noMore: string[] = [
  'No more wondering what to teach next.',
  'No more building every class from zero.',
  'No more scattered tutorials and disconnected references.',
  'No more repeating the same exercises because you ran out of ideas.',
  'No more vague corrections.',
  'No more wondering how to evaluate student progress.',
  'No more spending your personal time preparing every lesson.',
  'No more knowing the technique but struggling to turn it into a structured class.',
]
